import React from 'react';
import { PersonalityList } from '../../../../types';
import styles from './lesson-video-template.module.css';

type VideoMetaProps = {
  personalities?: PersonalityList[];
  subtitle: string | undefined;
  title: string | undefined;
  summary?: string | undefined;
  courseId?: string | undefined;
};

// @ts-ignore
const formatter = new Intl.ListFormat('en-gb', {
  style: 'long',
  type: 'conjunction',
});

function formattedPersonalityList(personalities: PersonalityList[]) {
  return formatter.format(
    personalities.map((personality: PersonalityList) => personality.name)
  );
}

function VideoMeta({
  courseId,
  subtitle,
  title,
  summary,
  personalities = [],
}: VideoMetaProps) {
  return (
    <>
      <div className={styles.titleContainer}>
        <h2 className={styles.lesson}>{subtitle}</h2>
        <h1 className={styles.title}>{title}</h1>
        {courseId !== 'financial-peace-university' && summary ? (
          <p
            className={styles.summary}
            dangerouslySetInnerHTML={{ __html: summary }}
          ></p>
        ) : null}
      </div>
      <div className={styles.videoMetaContainer}>
        <div className={styles.personalityThumbnails}>
          {personalities.map((personality: PersonalityList, idx: number) => (
            <img
              style={{ zIndex: 10 - idx }}
              key={personality.name}
              src={personality.profile_image}
              className={styles.thumbnail}
              alt={personality.name}
            />
          ))}
        </div>
        <div className={styles.featureContainer}>
          <h4 className={styles.feature}>featuring</h4>
          <h5 className={styles.personalityName}>
            {formattedPersonalityList(personalities)}
          </h5>
        </div>
      </div>
    </>
  );
}

export default VideoMeta;
